import { useMutation } from '@tanstack/react-query';
import { voiceOtpMutationFunction } from '@/modules/Auth/queries/voiceOtp/voiceOtpMutationFunction.ts';

const useCreateVoiceOtpRequest = () => {
  return useMutation({
    mutationFn: voiceOtpMutationFunction,
  });
};

export default useCreateVoiceOtpRequest;
